module.exports = __webpack_public_path__ + "static/media/amazon.109ec5e4.png";